import BlockReplacement from './base/block-replacement';
export default BlockReplacement.extend().reopenClass({
  replacement: {
    pattern: /(?:[\s\S])?^#\s(.+)?$/m,
    replaceWith: 'Heading',
    captureGroupMapping: ['text'],
    config: 'allowMarkdownHeadings'
  }
});